// ════════════════════════════════════════════════════════════════════════════
// components/Cotizaciones/CotizacionRapida.jsx
// VERSIÓN CONECTADA CON PARTIDAS ESTÁNDAR (igual que PropuestaBuilder)
// ════════════════════════════════════════════════════════════════════════════

import React, { useState, useEffect } from 'react';

import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  IconButton,
  Divider,
  Alert,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  PictureAsPdf as PdfIcon,
  Search as SearchIcon,
  PersonAdd as PersonAddIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { toast } from 'react-toastify';
import { 
  getProspectos, 
  createProspecto, 
  crearCotizacionRapida,
   getCotizacionById 
} from '../../services/crmService';
import { 
  cargarPartidasEstandar, 
  cargarCategoriasPartida,
 
} from '../../services/crmWorkflowService';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import { useFiscal } from '../../hooks/useFiscal';

const CotizacionRapida = () => {
  const fiscal = useFiscal();
  const navigate = useNavigate();
  
  // ═══════════════════════════════════════════════════════════════════════
  // STATE
  // ═══════════════════════════════════════════════════════════════════════
  
  // Cliente
  const [prospectos, setProspectos] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [modalNuevoCliente, setModalNuevoCliente] = useState(false);
  
  const [nuevoCliente, setNuevoCliente] = useState({
    nombre: '',
    email: '',
    telefono: '',
    rnc_cedula: '',
    direccion: '',
    empresa: ''
  });
  
  // Partidas estándar (igual que PropuestaBuilder)
  const [partidas, setPartidas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  
  // Líneas de la cotización
  const [lineas, setLineas] = useState([]);
  
  // Observaciones y validez
  const [observaciones, setObservaciones] = useState('');
  const [validezDias, setValidezDias] = useState(30);
  
  const [loading, setLoading] = useState(false);
  const [loadingCatalogos, setLoadingCatalogos] = useState(true);
  const { id } = useParams(); 
  const [isEditing, setIsEditing] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  console.log("🔍 [Check URL] ID detectado en la ruta:", id);
  // ═══════════════════════════════════════════════════════════════════════
  // EFFECTS
  // ═══════════════════════════════════════════════════════════════════════
  
  

  useEffect(() => {
    if (id) {
      setIsEditing(true);
      cargarDatosParaEditar(id);
    }
  }, [id]);

  const cargarDatosParaEditar = async (cotId) => {
    setLoading(true);
    try {
      const response = await getCotizacionById(cotId);
      if (response.data?.success) {
        const cot = response.data.data;
        
        // Llenamos tus estados con los nombres exactos que usas
        setClienteSeleccionado(cot.prospecto);
        setLineas(cot.lineas || []);
        setObservaciones(cot.observaciones || '');
        setValidezDias(cot.validez_dias || 15);
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
      toast.error("No se pudieron cargar los datos de la cotización");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    cargarProspectos();
    cargarCatalogos();
  }, []);


  
  // ═══════════════════════════════════════════════════════════════════════
  // FUNCIONES DE CARGA
  // ═══════════════════════════════════════════════════════════════════════
  
  const cargarProspectos = async () => {
    try {
      const response = await getProspectos();
      const lista = response.data?.data?.prospectos || [];
      setProspectos(lista);
    } catch (error) {
      console.error('Error cargando prospectos:', error);
    }
  };
  
  const cargarCatalogos = async () => {
    try {
      setLoadingCatalogos(true);
      const partidasRes = await cargarPartidasEstandar();
      const catsRes = await cargarCategoriasPartida();
      
      const partidasData = partidasRes.data.data || partidasRes.data || [];
      const catsData = catsRes.data.data || catsRes.data || [];
      
      setPartidas(partidasData);
      setCategorias(catsData);
    } catch (err) {
      console.error('Error cargando catálogos:', err);
      toast.error('Error al cargar catálogo de partidas');
    } finally {
      setLoadingCatalogos(false);
    }
  };

const cargarDatosCotizacion = async (cotId) => {
  console.log(`🚀 [Fetch] Iniciando carga de cotización ID: ${cotId}...`);
  setLoadingData(true);
  try {
    const response = await getCotizacionById(cotId);
    console.log("📥 [Response Full] Mira la estructura en tu consola:", response.data);

    if (response.data?.success) {  const cot = response.data.data;
      
      // 1. Corregimos el Cliente (Probamos con 'prospecto' o 'cliente')
      const clienteData = cot.prospecto || cot.cliente;
      console.log("👤 [Check] Datos del cliente encontrados:", clienteData);
      setClienteSeleccionado(clienteData);
      
      // 2. Corregimos las Líneas (Probamos con 'lineas', 'partidas' o 'CotizacionLineas')
      const lineasData = cot.lineas || cot.partidas || cot.CotizacionLineas || [];
      console.log("📦 [Check] Partidas encontradas:", lineasData);
      
      // Mapeamos para que los campos coincidan con lo que tu tabla necesita
     const lineasMapeadas = lineasData.map((l, index) => ({
        ...l,
        // Usamos el ID de la base de datos o el índice como fallback para la "key"
        id_temp: l.id || index, 
        codigo: l.codigo || l.id_producto || '',
        nombre: l.nombre || l.descripcion || '',
        cantidad: Number(l.cantidad) || 0,
        precio_unitario: Number(l.precio_unitario) || 0,
        total: Number(l.total) || (Number(l.cantidad) * Number(l.precio_unitario))
      }));
      
      console.log("🎯 [Final] Lineas listas para mostrar:", lineasMapeadas);
      setLineas(lineasMapeadas);
      
      // 3. Otros campos
      setObservaciones(cot.observaciones || '');
      setValidezDias(cot.validez_dias || 15);
      
      console.log("✅ [Success] Estados actualizados.");
    }
  } catch (error) {
    console.error("❌ [Error] Falló la carga:", error);
  } finally {
    setLoadingData(false);
  }
};
// Disparador del modo edición
useEffect(() => {
  if (id) {
    console.log("🛠️ [Mode] Detectado ID en URL. Cambiando a Modo Edición.");
    setIsEditing(true);
    cargarDatosCotizacion(id);
  } else {
    console.log("✨ [Mode] No hay ID en URL. Modo Creación Nueva.");
    setIsEditing(false);
  }
}, [id]);

useEffect(() => {
  if (id) {
    setIsEditing(true);
    cargarDatosCotizacion(id);
  }
}, [id]);
  
  
  // ═══════════════════════════════════════════════════════════════════════
  // FUNCIONES DE CLIENTE
  // ═══════════════════════════════════════════════════════════════════════
const handleCrearCliente = async () => {
  if (!nuevoCliente.nombre || !nuevoCliente.email) {
    toast.error('Nombre y email son requeridos');
    return;
  }
  
  try {
    const datosCliente = {
      ...nuevoCliente,
      fuente: 'cotizacion_rapida', // Valor seguro para el Enum del backend
      estatus: 'contacto_inicial', // Valor seguro para el Enum del backend
      proyecto_tipo: 'infraestructura'
    };
    
const response = await createProspecto(datosCliente);

// 🔍 LA RUTA EXACTA SEGÚN TU LOG:
// response.data es el objeto raíz
// response.data.data contiene { prospecto: {...}, oportunidad: {...} }
const clienteCreado = response.data?.data?.prospecto;

console.log("🎯 ¡Ahora sí! Prospecto extraído:", clienteCreado);

if (!clienteCreado || !clienteCreado.id) {
  console.error("❌ Aún no llegamos al ID. Estructura completa:", response.data);
  toast.error("Error al capturar el ID del cliente");
  return;
}

// SI LLEGAMOS AQUÍ, EL ÉXITO ES TOTAL
toast.success(`✅ Cliente "${clienteCreado.nombre}" capturado`);

setClienteSeleccionado(clienteCreado);
setModalNuevoCliente(false);

// Limpiar y recargar
setNuevoCliente({ nombre: '', email: '', telefono: '', rnc_cedula: '', direccion: '', empresa: '' });
await cargarProspectos();
   
    
  } catch (error) {
    console.error('Error creando cliente:', error);
    const mensaje = error.response?.data?.error || 'Error al crear el cliente';
    toast.error(`❌ ${mensaje}`);
  }
};
  // ═══════════════════════════════════════════════════════════════════════
  // FUNCIONES DE PARTIDAS (igual que PropuestaBuilder)
  // ═══════════════════════════════════════════════════════════════════════
  
  const añadirLinea = (partida) => {
    const nueva = {
      id: Date.now(),
      partida_id: partida.id,
      codigo: partida.codigo,
      nombre: partida.nombre,
      descripcion: partida.descripcion || '',
      cantidad: 1,
      unidad: partida.unidad || 'glb',
      precio_unitario: 0,
      subtotal: 0,
      total: 0
    };
    setLineas([...lineas, nueva]);
    toast.success(`Partida "${partida.nombre}" agregada`);
  };
  
  const actualizarLinea = (id, campo, valor) => {
    setLineas(lineas.map(l => {
      if (l.id === id) {
        const act = { ...l, [campo]: valor };
        if (['cantidad', 'precio_unitario'].includes(campo)) {
          const subtotal = (act.cantidad || 0) * (act.precio_unitario || 0);
          act.subtotal = subtotal;
          act.total = subtotal;
        }
        return act;
      }
      return l;
    }));
  };
  
  const eliminarLinea = (id) => {
    setLineas(lineas.filter(l => l.id !== id));
    toast.info('Partida eliminada');
  };
  
  // ═══════════════════════════════════════════════════════════════════════
  // CÁLCULOS
  // ═══════════════════════════════════════════════════════════════════════
  
  const calcularTotales = () => {
    const subtotal = lineas.reduce((sum, l) => sum + l.subtotal, 0);
    const itbis = subtotal * ((fiscal.impuesto_tasa ?? 18) / 100);
    const total = subtotal + itbis;
    
    return { subtotal, itbis, total };
  };
  
  const { subtotal, itbis, total } = calcularTotales();
  
  // ═══════════════════════════════════════════════════════════════════════
  // SUBMIT
  // ═══════════════════════════════════════════════════════════════════════
const handleSubmit = async () => {
  if (!clienteSeleccionado || (!clienteSeleccionado.id && !clienteSeleccionado.prospecto_id)) {
    toast.error('El cliente seleccionado no tiene un ID válido');
    return;
  }

  setLoading(true);
  try {
    const currentId = clienteSeleccionado.id || clienteSeleccionado.prospecto_id;

    const data = {
      prospecto_id: currentId,
      cliente: {
        id: currentId,
        nombre: clienteSeleccionado.nombre,
        empresa: clienteSeleccionado.empresa,
        // 1. RESTAURAMOS EL FLUJO: Se queda como 'nuevo' o 'lead'
        // Cambia 'nuevo' por el valor exacto que use tu backend para los Leads
        estatus: 'nuevo' 
      },
      partidas: lineas.map(l => ({
        codigo: l.codigo,
        nombre: l.nombre,
        cantidad: Number(l.cantidad),
        precio_unitario: Number(l.precio_unitario)
      })),
      observaciones,
      validez_dias: Number(validezDias),
      // Enviamos el total para que cuando le des a "Convertir" 
      // el sistema ya sepa de cuánto es la oportunidad
      presupuesto_estimado: lineas.reduce((acc, item) => acc + (item.cantidad * item.precio_unitario), 0)
    };

    const response = await crearCotizacionRapida(data);
    
    if (response.data.success) {
      toast.success('🚀 Cotización creada. El prospecto se mantiene como Lead.');
      // 2. IMPORTANTE: Redirigir a la lista de prospectos o cotizaciones, 
      // NO al Pipeline todavía, porque aún no es una oportunidad.
      navigate('/prospectos'); 
    }
  } catch (error) {
    console.error("❌ Error:", error.response?.data);
    toast.error(error.response?.data?.error || 'Error al procesar');
  } finally {
    setLoading(false);
  }
};
  // ═══════════════════════════════════════════════════════════════════════
  // FILTRADO DE PARTIDAS
  // ═══════════════════════════════════════════════════════════════════════
  
  const partidasFiltradas = categoriaSeleccionada
    ? partidas.filter(p => p.CategoriaPartidaId === categoriaSeleccionada || p.categoria_id === categoriaSeleccionada)
    : partidas;
  
  // ═══════════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════════
  
  if (loadingCatalogos) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography>Cargando catálogos...</Typography>
      </Box>
    );
  }
  
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        📄 Nueva Cotización Rápida
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Crea cotizaciones sin pasar por el flujo completo del CRM
      </Typography>
      
      {/* ════════════════════════════════════════════════════════════════ */}
      {/* SECCIÓN CLIENTE */}
      {/* ════════════════════════════════════════════════════════════════ */}
      
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">👤 Cliente</Typography>
            <Button
              variant="outlined"
              size="small"
              startIcon={<PersonAddIcon />}
              onClick={() => setModalNuevoCliente(true)}
            >
              Nuevo Cliente
            </Button>
          </Box>
          
          <Autocomplete
            options={prospectos}
            getOptionLabel={(option) => {
              const nombre = option.nombre || '';
              const empresa = option.empresa ? ` (${option.empresa})` : '';
              const email = option.email ? ` - ${option.email}` : '';
              return `${nombre}${empresa}${email}`;
            }}
            value={clienteSeleccionado}
            onChange={(e, newValue) => setClienteSeleccionado(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Buscar cliente"
                placeholder="Escribe nombre, empresa o email..."
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      <SearchIcon sx={{ color: 'action.active', mr: 1 }} />
                      {params.InputProps.startAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
          
          {clienteSeleccionado && (
            <Alert severity="success" sx={{ mt: 2 }}>
              <strong>Cliente seleccionado:</strong> {clienteSeleccionado.nombre}
              {clienteSeleccionado.empresa && ` (${clienteSeleccionado.empresa})`}
              <br />
              {clienteSeleccionado.email && `Email: ${clienteSeleccionado.email}`}
              {clienteSeleccionado.rnc_cedula && ` • ${fiscal.id_fiscal_empresa_label || 'RNC'}/${fiscal.id_fiscal_persona_label || 'Cédula'}: ${clienteSeleccionado.rnc_cedula}`}
            </Alert>
          )}
        </CardContent>
      </Card>
      
      {/* ════════════════════════════════════════════════════════════════ */}
      {/* SECCIÓN PARTIDAS (igual que PropuestaBuilder) */}
      {/* ════════════════════════════════════════════════════════════════ */}
      
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            📦 Agregar Partidas del Catálogo
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2, mb: 2, flexDirection: { xs: 'column', md: 'row' } }}>
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>Filtrar por Categoría</InputLabel>
              <Select
                value={categoriaSeleccionada || ''}
                onChange={(e) => setCategoriaSeleccionada(e.target.value || null)}
                label="Filtrar por Categoría"
              >
                <MenuItem value=""><em>Todas ({partidas.length})</em></MenuItem>
                {categorias.map((cat) => (
                  <MenuItem key={cat.id} value={cat.id}>
                    {cat.nombre} ({partidas.filter(p => (p.CategoriaPartidaId || p.categoria_id) === cat.id).length})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Autocomplete
              fullWidth
              options={partidasFiltradas}
              getOptionLabel={(opt) => `[${opt.codigo || 'N/A'}] ${opt.nombre} - ${opt.unidad || 'UND'}`}
              onChange={(e, val) => {
                if (val) añadirLinea(val);
              }}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  label={`Buscar Partida (${partidasFiltradas.length} disponibles)`}
                  placeholder="Escribe para buscar..."
                />
              )}
              disabled={partidasFiltradas.length === 0}
            />
          </Box>
        </CardContent>
      </Card>
      
      {/* ════════════════════════════════════════════════════════════════ */}
      {/* TABLA DE PARTIDAS AGREGADAS */}
      {/* ════════════════════════════════════════════════════════════════ */}
      
      {lineas.length > 0 && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              📋 Partidas Agregadas ({lineas.length})
            </Typography>
            
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                    <TableCell>Código</TableCell>
                    <TableCell>Concepto</TableCell>
                    <TableCell align="right">Cant.</TableCell>
                    <TableCell align="right">Precio</TableCell>
                    <TableCell align="right">Subtotal</TableCell>
                    <TableCell align="center">Acción</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {lineas.map((linea) => (
                    <TableRow key={linea.id}>
                      <TableCell>
                        <Typography variant="caption">{linea.codigo}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="bold">{linea.nombre}</Typography>
                        <TextField 
                          fullWidth 
                          multiline 
                          variant="standard" 
                          size="small"
                          value={linea.descripcion}
                          onChange={(e) => actualizarLinea(linea.id, 'descripcion', e.target.value)}
                          placeholder="Descripción adicional..."
                        />
                      </TableCell>
                      <TableCell align="right">
                        <input 
                          type="number" 
                          style={{ width: 60, padding: 4 }} 
                          value={linea.cantidad} 
                          onChange={(e) => actualizarLinea(linea.id, 'cantidad', parseFloat(e.target.value) || 0)} 
                        />
                        <Typography variant="caption" display="block">{linea.unidad}</Typography>
                      </TableCell>
                      <TableCell align="right">
                        <input 
                          type="number" 
                          style={{ width: 100, padding: 4 }} 
                          value={linea.precio_unitario} 
                          onChange={(e) => actualizarLinea(linea.id, 'precio_unitario', parseFloat(e.target.value) || 0)} 
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="body2" fontWeight="bold">
                          ${linea.subtotal.toLocaleString('es-DO')}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <IconButton 
                          size="small" 
                          color="error" 
                          onClick={() => eliminarLinea(linea.id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
      
      {/* ════════════════════════════════════════════════════════════════ */}
      {/* TOTALES Y OBSERVACIONES */}
      {/* ════════════════════════════════════════════════════════════════ */}
      
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>📝 Observaciones</Typography>
              
              <TextField
                fullWidth
                multiline
                rows={4}
                label="Observaciones o términos adicionales"
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
                placeholder="Ej: Cotización válida por 30 días. Precios sujetos a cambio..."
              />
              
              <TextField
                fullWidth
                type="number"
                label="Validez (días)"
                value={validezDias}
                onChange={(e) => setValidezDias(parseInt(e.target.value) || 30)}
                sx={{ mt: 2 }}
                inputProps={{ min: 1 }}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>💰 Totales</Typography>
              
              <Box sx={{ bgcolor: '#f5f5f5', p: 3, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Subtotal:</Typography>
                  <Typography fontWeight="bold">
                    ${subtotal.toLocaleString('es-DO', { minimumFractionDigits: 2 })}
                  </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>{fiscal.impuesto_label || 'ITBIS'} ({fiscal.impuesto_tasa ?? 18}%):</Typography>
                  <Typography fontWeight="bold">
                    ${itbis.toLocaleString('es-DO', { minimumFractionDigits: 2 })}
                  </Typography>
                </Box>
                
                <Divider sx={{ my: 1 }} />
                
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="h6">TOTAL:</Typography>
                  <Typography variant="h6" color="primary" fontWeight="bold">
                    ${total.toLocaleString('es-DO', { minimumFractionDigits: 2 })}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      
      {/* ════════════════════════════════════════════════════════════════ */}
      {/* BOTONES */}
      {/* ════════════════════════════════════════════════════════════════ */}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          size="large"
          onClick={() => navigate('/cotizaciones')}
        >
          Cancelar
        </Button>
        
        <Button
          variant="contained"
          size="large"
          startIcon={<PdfIcon />}
          onClick={handleSubmit}
          disabled={loading || !clienteSeleccionado || lineas.length === 0}
        >
          {loading ? 'Generando...' : 'Generar Cotización'}
        </Button>
      </Box>
      
      {/* ════════════════════════════════════════════════════════════════ */}
      {/* MODAL NUEVO CLIENTE */}
      {/* ════════════════════════════════════════════════════════════════ */}
      
      <Dialog open={modalNuevoCliente} onClose={() => setModalNuevoCliente(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Nuevo Cliente
            <IconButton onClick={() => setModalNuevoCliente(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Nombre / Razón Social"
                value={nuevoCliente.nombre}
                onChange={(e) => setNuevoCliente({ ...nuevoCliente, nombre: e.target.value })}
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Empresa"
                value={nuevoCliente.empresa}
                onChange={(e) => setNuevoCliente({ ...nuevoCliente, empresa: e.target.value })}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                type="email"
                label="Email"
                value={nuevoCliente.email}
                onChange={(e) => setNuevoCliente({ ...nuevoCliente, email: e.target.value })}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Teléfono"
                value={nuevoCliente.telefono}
                onChange={(e) => setNuevoCliente({ ...nuevoCliente, telefono: e.target.value })}
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={`${fiscal.id_fiscal_empresa_label || 'RNC'} / ${fiscal.id_fiscal_persona_label || 'Cédula'}`}
                value={nuevoCliente.rnc_cedula}
                onChange={(e) => setNuevoCliente({ ...nuevoCliente, rnc_cedula: e.target.value })}
                placeholder="123456789 o 001-1234567-8"
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Dirección"
                value={nuevoCliente.direccion}
                onChange={(e) => setNuevoCliente({ ...nuevoCliente, direccion: e.target.value })}
                multiline
                rows={2}
              />
            </Grid>
          </Grid>
        </DialogContent>
        
        <DialogActions>
          <Button onClick={() => setModalNuevoCliente(false)}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={handleCrearCliente}>
            Crear Cliente
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CotizacionRapida;